import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const OpenDocIcon = (props) => {
  const {fill = '#374151', other} = props;
  return (
    <SvgIcon {...props} width="18.414" height="18.414" viewBox="0 0 18.414 18.414" {...other}>
      <path fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"  d="M10,582H6a2,2,0,0,0-2,2v10a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2v-4m-4-10h6m0,0v6m0-6L10,590" transform="translate(-3 -578.586)" />
    </SvgIcon>
  );
};

export default OpenDocIcon;
